import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class CodeStateListItem extends SearchModelBase {
    code: string = '';
    stateName: string = '';
    country: string = '';
    cid: string = '';
    cid2: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'Code', width: 50, dataIndex: 'code'}),
        XCol.Create({ col: 1, text: 'State Name', width: 300, dataIndex: 'stateName'}),
        XCol.Create({ col: 2, text: 'Country', width: 100, dataIndex: 'country'})
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: CodeStateListItem.prototype.code, orderByAscending: false };

    public static formatData(data: CodeStateListItem[]) {
        return data.map((d: CodeStateListItem) => ({
          ...d,
        }));
    }

}
